import { USERS_ERROR, GET_USER, GET_USERS, CLEAR_USER, TOGGLE_FAVORITE, AUTH_ERROR_CLIENT, LOGOUT_CLIENT } from '../actions/types';

const initialState = {
  user: {},
  pass: false,
  users: [],
  loading: true,
  error: {}
}

export default function(state = initialState, action){
  const { type, payload } = action;

  switch(type){
    case GET_USER:
      if(payload?.pass){
        return {
          ...state,
          user: payload,
          pass: payload.pass,
          loading: false
        }
      } else {
        return {
          ...state,
          user: payload,
          loading: false
        }
      }
    case GET_USERS:
      return {
        ...state,
        users: payload,
        loading: false
      }
    case USERS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      }
    case TOGGLE_FAVORITE:
      return {
        ...state,
        user: { ...state.user, favorites: payload },
        loading: false
      }
    case CLEAR_USER: 
    case AUTH_ERROR_CLIENT:
    case LOGOUT_CLIENT:
      return {
        ...state,
        user: {},
        loading: false
      };
    default:
      return state;
  }
}